import type { Sample } from '../types/kit';

export const samples: Sample[] = [
  {
    label: 'VOLUME 01 · COVER',
    thumb: 'COVER',
    title: '13 ready-to-run weekly sessions.',
    summary: 'Weeks 1–13 for ages 5–8, with approximately 45 minutes per session.',
    image: 'https://cdn.magicpatterns.com/uploads/rRG8wXNyk6WvBtHtrznaDV/01_portada.png',
    alt: 'Cover of Kids Activity Club Volume 01: Play, Connect & Cooperate',
  },
  {
    label: 'WEEK 03 · PRINT & ADAPT · PAGE 10',
    thumb: 'WEEK 03',
    title: 'The cards, models and answers are supplied.',
    summary: 'Cut-out museum cards, leader display models, a round-by-round answer key and adaptations by age.',
    image: 'https://cdn.magicpatterns.com/uploads/5niuu53wUW7CRoQxA26xHM/02_tarjetas_museo.png',
    alt: 'Week 03 page: museum cards and models with answer key and age adaptations',
  },
  {
    label: 'WEEK 06 · PRINT & ADAPT · PAGE 19',
    thumb: 'WEEK 06',
    title: 'Story prompts ready to cut and play.',
    summary: 'Eight story starters, a sample four-part story, a story strip and adaptations for each age group.',
    image: 'https://cdn.magicpatterns.com/uploads/mVRgSLMF2fSLM19mw56itS/03_tarjetas_historias.png',
    alt: 'Week 06 page: eight story starters, sample story and story strip',
  },
  {
    label: 'WEEK 09 · PREPARE · PAGE 26',
    thumb: 'WEEK 09',
    title: 'Materials, setup and words already decided.',
    summary: 'Purpose, materials checklist, before-arrival steps, read-aloud text, a timed sequence and a comfort check.',
    image: 'https://cdn.magicpatterns.com/uploads/xovDoZdeSY2jiowF1XZFMR/04_ritmo_y_espejos.png',
    alt: 'Week 09 page: Rhythm & Mirrors preparation with materials, read-aloud and timeline',
  },
  {
    label: 'WEEK 10 · PRINT & ADAPT · PAGE 31',
    thumb: 'WEEK 10',
    title: 'Test sheets your group can fill in.',
    summary: 'A bridge test sheet with a fair-comparison checklist, an observation table and a leader check.',
    image: 'https://cdn.magicpatterns.com/uploads/5kRc1G5hLP8fTBHVpyEo65/05_puentes_de_papel.png',
    alt: 'Week 10 page: bridge test sheet with observation table and adaptations',
  },
];
